export default "__VITE_ASSET__CSYl3PYS__"